import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { providePrimeNG } from 'primeng/config';
import { DividerModule } from 'primeng/divider';
import { TabsModule } from 'primeng/tabs';

import { AppRoutingModule } from 'content-manager/src/app/app-routing.module';
import { AppComponent } from 'content-manager/src/app/app.component';
import { CoreModule } from 'content-manager/src/app/core/core.module';
import { NewChapterDialogComponent } from 'content-manager/src/app/projects/project/chapters/new-chapter-dialog/new-chapter-dialog.component';
import { ProjectChaptersComponent } from 'content-manager/src/app/projects/project/chapters/project-chapters.component';
import { ProjectContentEditorsComponent } from 'content-manager/src/app/projects/project/content-editors/project-content-editors.component';
import { SearchMemberComponent } from 'content-manager/src/app/projects/project/content-editors/search-member/search-member.component';
import { CreateProjectDialogComponent } from 'content-manager/src/app/projects/project/create-project-dialog/create-project-dialog.component';
import { ProjectDetailsComponent } from 'content-manager/src/app/projects/project/details/project-details.component';
import { ProjectReturnToEditorDialogComponent } from 'content-manager/src/app/projects/project/details/return-to-editor-dialog/project-return-to-editor-dialog.component';
import { AuthorsRendererComponent } from 'content-manager/src/app/projects/project/papers/author/authors-renderer.component';
import { CommentsRendererComponent } from 'content-manager/src/app/projects/project/papers/comment/comments-renderer.component';
import { ProjectPapersComponent } from 'content-manager/src/app/projects/project/papers/project-papers.component';
import { ProjectPlagiarismReportCheckInfoDialogComponent } from 'content-manager/src/app/projects/project/plagiarism-reports/check-info-dialog/project-plagiarism-report-check-info-dialog.component';
import { ProjectPlagiarismReportsComponent } from 'content-manager/src/app/projects/project/plagiarism-reports/project-plagiarism-reports.component';
import { PlagiarismCheckResultRendererComponent } from 'content-manager/src/app/projects/project/plagiarism-reports/renderers/check-result/plagiarism-check-result-renderer.component';
import { ProjectHeaderComponent } from 'content-manager/src/app/projects/project/project-layout/header/project-header.component';
import { ProjectLayoutComponent } from 'content-manager/src/app/projects/project/project-layout/project-layout.component';
import { ChapterThemasComponent } from 'content-manager/src/app/projects/project/themas/chapter-themas/chapter-themas.component';
import { ProjectLevelThemasComponent } from 'content-manager/src/app/projects/project/themas/project-level-themas/project-level-themas.component';
import { ProjectThemasComponent } from 'content-manager/src/app/projects/project/themas/project-themas.component';
import { ThemaPickerComponent } from 'content-manager/src/app/projects/project/themas/thema-picker/thema-picker.component';
import { ChapterTopicsComponent } from 'content-manager/src/app/projects/project/topics/chapter-topics/chapter-topics.component';
import { ProjectLevelTopicsComponent } from 'content-manager/src/app/projects/project/topics/project-level-topics/project-level-topics.component';
import { ProjectTopicsComponent } from 'content-manager/src/app/projects/project/topics/project-topics.component';
import { TopicPickerComponent } from 'content-manager/src/app/projects/project/topics/topic-picker/topic-picker.component';
import { WelcomeBlockComponent } from 'content-manager/src/app/projects/project/welcome-block/welcome-block.component';
import { ProjectListComponent } from 'content-manager/src/app/projects/project-list.component';
import { ServicesEnum } from 'sc-common';
import { BACKGROUND_PROCESS_CONFIG } from 'sc-common/core/services/background-process/background-process-config';
import { ErrorPagesModule } from 'sc-external/shared/components/error/error-pages.module';
import { ExternalSharedModule } from 'sc-external/shared/external-shared.module';
import ExternalThemePreset from 'sc-external/themes/external-theme-preset';

@NgModule({
    declarations: [
        AppComponent,
        NewChapterDialogComponent,
        ProjectChaptersComponent,
        ProjectContentEditorsComponent,
        ProjectDetailsComponent,
        ProjectHeaderComponent,
        ProjectLayoutComponent,
        ProjectPapersComponent,
        ProjectPlagiarismReportsComponent,
        ProjectThemasComponent,
        ChapterThemasComponent,
        ProjectLevelThemasComponent,
        ThemaPickerComponent,
        ProjectTopicsComponent,
        ChapterTopicsComponent,
        ProjectLevelTopicsComponent,
        TopicPickerComponent,
        ProjectListComponent,
        CreateProjectDialogComponent,
        SearchMemberComponent,
        ProjectPlagiarismReportCheckInfoDialogComponent,
        PlagiarismCheckResultRendererComponent,
        AuthorsRendererComponent,
        CommentsRendererComponent,
        WelcomeBlockComponent,
        ProjectReturnToEditorDialogComponent
    ],
    providers: [
        {
            provide: BACKGROUND_PROCESS_CONFIG,
            useValue: { allowedServicess: [ServicesEnum.ContentManager] }
        },
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: ExternalThemePreset,
                options: {
                    darkModeSelector: false
                }
            },
            ripple: false
        })
    ],
    bootstrap:
        [AppComponent],
    imports:
        [BrowserModule,
            BrowserAnimationsModule,
            AppRoutingModule,
            CoreModule,
            DividerModule,
            ExternalSharedModule,
            RouterModule,
            TabsModule,
            FormsModule,
            ReactiveFormsModule,
            AccordionModule,
            AutoCompleteModule,
            ErrorPagesModule]
})
export class AppModule { }

